/* Automatically generated file, do not update manually */
export default {
  VenusLens: {
    undefined: '0xe4C455cBf870A86399043B8A36A669FfA1583e95',
  },
  PoolLens: {
    146: '0x3567B16050cB90236997eF47B1941502e85d65f3',
    9745: '0xE67B5097b8dC55aCECaB82102A3042078f016550',
    undefined: '0x142160A2E699e33af337741f157D96aAd6bC72aA',
  },
  PoolRegistry: {
    146: '0xeA231B942a767BFEc5C0bAe31227C3f0F3Cb5566',
    9745: '0x0781BD52BA23E163AfAdcCb9701681489560DB3C',
    undefined: '0x147780799840d541C1d7c998F0cbA996d11D62bb',
  },
  LegacyPoolComptroller: {
    undefined: '0xfD36E2c2a6789Db23113685031d7F16329158384',
  },
  VaiController: {
    undefined: '0x004065D34C6b18cE4370ced1CeBDE94865DbFAFE',
  },
  VaiVault: {
    undefined: '0x0667Eed0a0aAb930af74a3dfeDD263A73994f216',
  },
  XvsTokenMultichain: {
    undefined: '0x4a971e87ad1F61f7f3081645f52a99277AE917cF',
  },
  XvsVault: {
    undefined: '0x133120607C018c949E91AE333785519F6d947e01',
  },
  XvsStore: {
    undefined: '0xFE548630954129923f63113923eF5373E10589d3',
  },
  GovernorBravoDelegate: {
    undefined: '0x2d56dC077072B53571b8252008C60e945108c75a',
  },
  XvsVesting: {
    undefined: '0xb28Dec7C7Ac80f4D0B6a1B711c39e444cDE8B2cE',
  },
  VrtConverter: {
    undefined: '0x92572fB60f4874d37917C53599cAe5b085B9Facd',
  },
  Maximillion: {
    undefined: '0x5efA1e46F4Fd738FF721F5AebC895b970F13E8A1',
  },
  XsequenceMulticall: {
    146: '0xd130B43062D875a4B7aF3f8fc036Bc6e9D3E1B3E',
    9745: '0xd130B43062D875a4B7aF3f8fc036Bc6e9D3E1B3E',
    undefined: '0xd130B43062D875a4B7aF3f8fc036Bc6e9D3E1B3E',
  },
  Multicall3: {
    146: '0xca11bde05977b3631167028862be2a173976ca11',
    9745: '0xca11bde05977b3631167028862be2a173976ca11',
    undefined: '0xca11bde05977b3631167028862be2a173976ca11',
  },
  ResilientOracle: {
    146: '0xd05b05590609c3610161e60eb41eC317c7562408',
    9745: '0xd05b05590609c3610161e60eb41eC317c7562408',
    undefined: '0x21FC48569bd3a6623281f55FC1F8B48B9386907b',
  },
  Prime: {
    undefined: '0xE76d2173546Be97Fa6E18358027BdE9742a649f7',
  },
  VTreasury: {
    undefined: '0xF322942f644A996A617BD29c16bd7d231d9F35E9',
  },
  VTreasuryV8: {
    146: '0x172bC36d3f092453cE6F3F9B30F1d6Ac365C4FfD',
    9745: '0x2e9D14A5E9e20771c7f9afdF9b933e3f0AB09174',
    undefined: '0x104c01EB7b4664551BE6A9bdB26a8C5c6Be7d3da',
  },
  XVSProxyOFTDest: {
    undefined: '0xbBe46bAec851355c3FC4856914c47eB6Cea0B8B4',
  },
  XVSProxyOFTSrc: {
    undefined: '0x0E132cd94fd70298b747d2b4D977db8d086e5fD0',
  },
  ZyFiVault: {
    undefined: '0xbA72A10ce8496DC9C13b9eE8c35fcCD3809d3C81',
  },
  EnclabsVeUSDTreveeVeManager: {
    146: '0x9FbD3988dd9a7A2f1A9c312669f3a4EDA462555C',
  },
  EnclabsVeETHTreveeVeManager: {
    146: '0xfa24b79af1e6a287a3aad7229216f8930d4daccb',
  },
  EnclabsTreveeVeUSD: {
    146: '0xd02962dc00a058a00fc07a8aa9f760ab6d9bd163',
  },
  EnclabsTreveeVeETH: {
    146: '0xb9ea44d1aa76d5cfd475c2800e186d3dea2141a4',
  },
  TreveeVeUSD: {
    146: '0x0966cae7338518961c2d35493d3eb481a75bb86b',
  },
  TreveeVeETH: {
    146: '0x1ec2b9a77a7226acd457954820197f89b3e3a578',
  },
  TreveeVeUSDVoter: {
    146: '0xb84194e28f624bbba3c9181f3a1120ee76469337',
  },
  TreveeVeETHVoter: {
    146: '0x43739B96B19aE7C2E0d80BE7832325846f55Fa05',
  },
  VTokenVenclabsVeUSDCore: {
    146: '0x1053fc8c4eaead1edd5276a58e9bddf1001ba143',
  },
  SwapRouter: {
    undefined: {},
  },
  NativeTokenGateway: {
    146: {
      '0xccadfcfaa71407707fb3dc93d7d83950171aa2c9': '0xb95f8ccbd23a98fb92da2976a170498a6b8d488a',
      '0x1db5134ee31278809b2d85fab2796141dbe0d041': '0x4fe8960c5bf853d8b019fc84656ab665391016bc',
    },
    9745: {
      '0xa3f48548562a30a33257a752d396a20b4413e8e3': '0x40ad0ca94a7c09f3a40302fd2de1deb53a38d315',
    },
    undefined: {
      '0x59d10988974223b042767aabfb6d926863069535': '0x521f59b2670bcc70961FB2edD4F62c3f3B1E7f6b',
    },
  },
};
